import { useEffect } from 'react';

const DynamicMetaTags = ({ clubSettings, platformSettings, landing }) => {
  useEffect(() => {
    if (!clubSettings && !platformSettings) return;

    const settings = clubSettings || platformSettings;
    
    // Update document title
    const title = landing?.page_title || (settings.club_name 
      ? `${settings.club_name} - الموقع الرسمي`
      : settings.platform_name || 'منصة الأندية الرياضية');
    
    document.title = title;
    
    // Update meta description
    const description = landing?.meta_description || settings.club_description || settings.description || 
      `الموقع الرسمي لـ${settings.club_name || settings.platform_name}. تابع آخر الأخبار والمباريات.`;
    
    updateMetaTag('description', description);
    updateMetaTag('title', title);
    
    // Update Open Graph tags
    updateMetaTag('og:title', title, 'property');
    updateMetaTag('og:description', description, 'property');
    updateMetaTag('og:site_name', settings.club_name || settings.platform_name, 'property');
    if (landing?.seo_og_image) {
      const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
      const ogImageUrl = landing.seo_og_image.startsWith('http') ? landing.seo_og_image : `${API_BASE_URL}/api/files/${landing.seo_og_image}`;
      updateMetaTag('og:image', ogImageUrl, 'property');
      updateMetaTag('twitter:image', ogImageUrl);
    }
    
    // Update Twitter tags
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    
    // Update theme colors if available
    if (settings.primary_color) {
      updateMetaTag('theme-color', settings.primary_color);
      updateMetaTag('msapplication-TileColor', settings.primary_color);
    }
    
    // Update keywords
    const keywords = landing?.keywords || (settings.club_name 
      ? `${settings.club_name}, كرة قدم, رياضة, السعودية, ${settings.club_city || ''}, بطولات, مباريات`
      : 'منصة الأندية الرياضية, إدارة الأندية, كرة قدم, رياضة');
    
    updateMetaTag('keywords', keywords);
    
    // ملاحظة: أيقونة المتصفح (favicon) لا تُستبدل من هنا عمداً — تبقى ثابتة من أصول public المحلية
    // لضمان ظهور شعار المنصة الرسمي فوراً وبثبات في التبويب، بمعزل عن إعدادات المنصة/API
    
  }, [clubSettings, platformSettings, landing]);

  const updateMetaTag = (name, content, attribute = 'name') => {
    if (!content) return;
    
    let element = document.querySelector(`meta[${attribute}="${name}"]`);
    
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    
    element.setAttribute('content', content);
  };

  return null; // This component doesn't render anything
};

export default DynamicMetaTags;